import React from 'react';
import {Route, IndexRoute} from 'react-router';

import App from './components/app/App.js';
import TicketLayout from './components/layouts/ticketLayout/TicketLayout.js';

import TicketViewPage from './components/pages/ticketView/TicketViewPage.js';

export default (
  <Route path="/" component={App}>
    <Route component={TicketLayout}>
      <IndexRoute component={TicketViewPage} />
      <Route path="*" component={TicketViewPage} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js